import { create } from 'zustand';

interface SessionTakeoverState {
  isOpen: boolean;
  open: () => void;
  close: () => void;
}

export const useSessionTakeoverStore = create<SessionTakeoverState>((set, get) => ({
  isOpen: false,
  open: () => {
    if (get().isOpen) return;
    set({ isOpen: true });
  },
  close: () => set({ isOpen: false }),
}));

export function triggerSessionTakeoverModal(): void {
  useSessionTakeoverStore.getState().open();
}
